// JS
import React, { useEffect, useState } from 'react';
import { randomId } from '../shared/utils';
import Slider from '../Slider';

// COMPOONENTS
import Product from '../Product';
import Button from '../Button';

// COMPONENT
const NewArrivalsSlider = ({
  getProductData,
  newArrivalsButtonLink,
  newArrivalsButtonLinkC,
  newArrivalsButtonLinkF,
  newArrivalsButtonLinkA,
  gaBlockName
}) => {
  const uniqueId = randomId();
  const [productData, setProductData] = useState(null);

  // GET DATA FROM NQ
  const getData = getProductData;

  // API DATA
  useEffect(() => {
    if (getData && getData.data) {
      setProductData(getData.data.products.products);
    }
  }, [getData]);

  return (
    <React.Fragment>
      <Slider
        name="new-arrivals-section-slider"
        responsive={{
          sm: { show: 2, spaceBetween: 10 },
          lg: { show: 3 },
          xl: { show: 4, spaceBetween: 12 }
        }}
        useGrid={true}
        usePagination={true}
        paginationOptions={{
          rounded: true,
          noContain: true,
          classes: {
            wrapper: '!justify-center !mt-1 md:!mt-10'
          }
        }}
      >
        {productData &&
          productData.map((slide, i) => {
            return (
              <Product
                key={'product-key-' + uniqueId}
                productID={slide.product.productid}
                productURL={slide.product.url}
                productName={slide.product.name}
                productPosition={i + 1}
                productCategory={slide.product.attributes.product_category}
                productBrand={slide.product.attributes.brand}
                productImage={slide.product.image}
                productImageAlternate={slide.product.attributes.alternative}
                productPrice={slide.product.option.price}
                productPromotionPrice={slide.product.option.promotionprice}
                productAspectOptions={{
                  classes: 'lg:aspect-h-11'
                }}
                gaBlockName={gaBlockName}
              />
            );
          })}
      </Slider>
      <div className="flex flex-row flex-wrap justify-evenly">
        <Button
          buttonColour="black"
          buttonLink={'/black-friday/black-friday-footwear/'}
          buttonLinkText="All Footwear"
          buttonAdditionalClasses={{
            classes: 'mt-7 md:mt-14 md:!w-1/3'
          }}
          gaBlockTitle={'View All Footwear'}
          gaBlockName={gaBlockName}
          gaBlockId={uniqueId}
        />

        <Button
          buttonColour="black"
          buttonLink={'/black-friday/black-friday-clothing/'}
          buttonLinkText="All Clothing"
          buttonAdditionalClasses={{
            classes: 'mt-7 md:mt-14 md:!w-1/3'
          }}
          gaBlockTitle={'View All Clothing'}
          gaBlockName={gaBlockName}
          gaBlockId={uniqueId}
        />

        <Button
          buttonColour="black"
          buttonLink={'/black-friday/black-friday-accessories/'}
          buttonLinkText="All Accessories"
          buttonAdditionalClasses={{
            classes: 'mt-7 md:mt-14 md:!w-1/3'
          }}
          gaBlockTitle={'View All Accessories'}
          gaBlockName={gaBlockName}
          gaBlockId={uniqueId}
        />

        <Button
          buttonColour="white"
          buttonLink={'/black-friday-offers/'}
          buttonLinkText="View All"
          buttonAdditionalClasses={{
            classes: 'mt-7 md:mt-14 md:!w-1/3'
          }}
          gaBlockTitle={'View All'}
          gaBlockName={gaBlockName}
          gaBlockId={uniqueId}
        />
      </div>
    </React.Fragment>
  );
};

export default NewArrivalsSlider;
